/**
 * Écran de chargement plein écran.
 * Affiché pendant la vérification de l'auth au démarrage.
 * Safe area gérée via pb-safe.
 */
export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white pt-safe pb-safe">
      <div className="mb-6">
        <img
          src="/assets/images/logo.png"
          alt="WiseLinker"
          className="w-20 h-20 object-contain animate-pulse-soft"
        />
      </div>
      <div className="flex gap-1.5">
        {[0, 1, 2].map(i => (
          <div
            key={i}
            className="w-2 h-2 rounded-full bg-brand-blue animate-bounce"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </div>
    </div>
  );
}
